import { View } from './view';

export const Checkbox = View;
